import React from 'react';
import Radium from 'radium';
import { func } from 'prop-types';
import { UTLabel, WithLoading, UTLoading } from '@widergy/energy-ui';

import UTTable from 'app/components/UTTable';
import UTModal from 'app/components/UTModal';
import withErrorScreen from 'app/components/UTErrorScreen/HOCs/withErrorScreen';
import { formResponsePropTypes } from 'redux/userFormHandlers';
import { activeRowSize, inactiveRowSize } from 'constants/sizes';
import { CLAIM } from 'constants/userForms';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';
import { DefaultViewport, MobileViewport } from 'constants/deviceSizes';

import ActionClaims from '../../components/FieldDetail/components/ActionClaims';
import FieldDetail from '../../components/FieldDetail';
import ConfirmAlert from '../../components/ConfirmAlert';
import MobileProceduresContainer from '../../components/FormsMobileList';

import styles from './styles';

/* eslint-disable react/prop-types */
const statusRenderer = ({ cellData, rowData }) => (
  <UTLabel error={rowData.status.isPending} semibold={rowData.status.isPending}>
    {cellData}
  </UTLabel>
);

/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */

const actionClaimsRenderer = handleOpenActionModal => ({ rowData }) => (
  <ActionClaims rowData={rowData} handleOpenActionModal={handleOpenActionModal} />
);

const columns = [
  { key: 'started_at', name: message('Claims:initDate'), width: 0.2 },
  {
    key: 'status_label',
    name: message('Commons:status'),
    width: 0.2,
    cellRenderer: statusRenderer
  },
  { key: 'form_name', name: message('Claims:type'), width: 0.2 },
  { key: 'external_id', name: message('Claims:number'), width: 0.15 }
];

function ClaimsScene({
  claims,
  onRowsRendered,
  onCloseActionModal,
  onOpenActionModal,
  onConfirmAction,
  actionRowModalIsOpen,
  actionOptions,
  appending
}) {
  return (
    <div style={styles.table}>
      <DefaultViewport>
        <UTTable
          columns={
            appConfig.claims.openableRow
              ? columns
              : [
                  ...columns,
                  {
                    key: 'action_claims',
                    name: message('Claims:actions'),
                    width: 0.17,
                    cellRenderer: actionClaimsRenderer(onOpenActionModal)
                  }
                ]
          }
          rows={claims}
          openable={appConfig.claims.openableRow}
          renderActiveRow={(rowData, positionStyle) => (
            <FieldDetail rowData={rowData} style={positionStyle} handleOpenActionModal={onOpenActionModal} />
          )}
          activeRowStyle={styles.activeRowStyle}
          rowHeight={(index, activeRowIndex) => (index === activeRowIndex ? activeRowSize : inactiveRowSize)}
          id={CLAIM}
          onRowsRendered={onRowsRendered}
          scrolleable
        />
      </DefaultViewport>
      <MobileViewport>
        <MobileProceduresContainer rows={claims} handleOpenActionModal={onOpenActionModal} />
      </MobileViewport>
      {appending && (
        <div style={styles.spinnerContainer}>
          <UTLoading loading={appending} size={45} text=" " />
        </div>
      )}
      <UTModal
        isOpen={actionRowModalIsOpen}
        onRequestClose={onCloseActionModal}
        cancelButton={{ text: message('Commons:back'), onPress: onCloseActionModal }}
        acceptButton={{
          text: message('Commons:confirm'),
          onPress: actionOptions && actionOptions.acceptOnPress
        }}
        title={actionOptions && actionOptions.modalTitle}
        contentLabel={actionOptions && actionOptions.contentLabel}
      >
        <ConfirmAlert
          onSubmit={onConfirmAction}
          message={actionOptions && actionOptions.message}
          withComment={actionOptions && actionOptions.withComment}
          name={actionOptions && actionOptions.name}
          placeholder={actionOptions && actionOptions.placeholder}
        />
      </UTModal>
    </div>
  );
}

ClaimsScene.propTypes = {
  claims: formResponsePropTypes,
  onRowsRendered: func.isRequired
};

export default WithLoading(props => props.loading)(
  withErrorScreen(props => !props.claims.length)(Radium(ClaimsScene))
);
